<template>
  <RevDrawer
    :has-padding="false"
    :name="MODAL_NAMES.SIM"
    :title="i18n(translations.title)"
  >
    <template #body>
      <SimModalBody />
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import { MODAL_NAMES } from '~/scopes/product-core/constants'

import translations from './SimModal.translations'
import SimModalBody from './components/SimModalBody/SimModalBody.vue'

const i18n = useI18n()
</script>
